import type {Message, SearchParams} from 'typings/portaro.be.types';
import { MessageMedium, MessageStatus, MessageTopic} from 'typings/portaro.be.types';
import type {SearchManager} from '../../search/search-manager';
import type {SearchManagerFactory} from '../../search/search-manager.factory';
import type CommonSearchDataService from '../../commons/data-services/common-search.data-service';

interface MessageSearchParams extends SearchParams {
    topic?: MessageTopic,
    messageMedium?: MessageMedium,
    messageStatus?: MessageStatus
}

export default class MessagesController {

    private searchManager: SearchManager<MessageSearchParams, Message>;

    /*@ngInject*/
    constructor(searchManagerFactory: SearchManagerFactory, commonSearchDataService: CommonSearchDataService<Message>) {
        this.searchManager = searchManagerFactory.createLocalSearch(commonSearchDataService.query, {type: 'message-search', kind: 'message'});
        this.searchManager.newSearch();
    }

    public filterUnsentPostReminders() {
        this.searchManager.newSearchWithParams({
            topic: MessageTopic.REMINDER,
            messageMedium: MessageMedium.POST,
            messageStatus: MessageStatus.UNSENT
        });
    }
}
